const styles = {
    nivelesNiñoGrid: {
        borderLeft:  { xs: "none", xl: "1px solid #D9D9D9" },
    }
}

export default styles;